<img [src]="iconPath" *ngIf="iconPath && iconPath !== ''" alt="" />
{{ iconText }}
